import React from "react";
import { useNavigate } from "react-router-dom";
import { createRoomSize } from "adminApi/RoomSizeApi/RoomSize";
import { RoomSizeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddRoomSizeForm from "./Componates/AddRoomSizeForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { validateForm } from "utils/validation";
import fields from "../json/RoomSizeFields.json";

const AddRoomSize = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Build initial values from field definitions
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors } = useFormChange(initialValues, RoomSizeRules);

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    // Send plain JSON — no file uploads in this form
    async (formValues) => await createRoomSize({ data: formValues }),
    (vals) => {
      const err = validateForm(vals, RoomSizeRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Room Size Created Successfully"
  );

  return (
    <>
      {loadingSubmit && <Spinner isSpinner={true} />}
      <AddRoomSizeForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
      />
    </>
  );
};

export default AddRoomSize;
